<swiper [config]="config" [effect]="'flip'" #swiper [virtual]="true">

  <ng-container>
    <ng-template swiperSlide #front>
      <div class="matches-card">
        <div class="card-front">
          <div class="card uk-flex">
            <div class="brand-logo position-relative">
              <ng-content select=".labels .label-danger"></ng-content>
              <!-- <div class="labels label-danger">fast filling</div> -->
              <div class="image">
                <img src="{{pollData.merchant.ipl_logo}}" class="w-100 fitimg">
              </div>
            </div>
            <div class="info">
              <p>{{pollData.merchant_poll}} </p>
              <a (click)="submitOpinion('agree',question,pollData)" class="btn-all agree">agree</a>
              <a (click)="submitOpinion('disagree',question,pollData)" class="btn-all disagree">Disagree</a>
              <p class="error" *ngIf="notAllowedToSubmit && !appService.getAccessToken()">{{errorMessage}}</p>
            </div>
          </div>
          <div class="card-footer" [innerHTML]="pollData.deals_descriptions">
          </div>
        </div>
        <!--card-front end-->
      </div>
    </ng-template>
  </ng-container>

  <ng-container>
    <ng-template swiperSlide #back>
      <div class="matches-card" *ngIf="backflip">
        <div class="card-back">
          <div class="card uk-flex">
            <div class="brand-logo position-relative">
              <div class="image">
                <img src="{{pollData.merchant.ipl_logo}}" class="w-100 fitimg">
              </div>
            </div>
            <div class="info">
              <p>Your response has been recorded.</p>
              <div class="progress progress-agree">
                <!-- <div [ngStyle]="{'width': agreePercent+'%'}" class="progress-bar">Agree</div>
                <div [ngStyle]="{'width': 100-agreePercent+'%'}" class="percentage">{{agreePercent}}%</div> -->
                <div [ngStyle]="{'width': agreePercent+'%'}" class="progress-bar"></div>
                <span class="review-text">Agree</span>
                <span class="percentage">{{agreePercent}}%</span>
              </div>
              <!--progress end-->
              <div class="progress mt-1 progress-disagree">
                <!-- <div [ngStyle]="{'width': disAgreePercent+'%'}" class="progress-bar">Disagree</div>
                <div [ngStyle]="{'width': 100-disAgreePercent+'%'}" class="percentage">{{disAgreePercent}}%</div> -->
                <div [ngStyle]="{'width': disAgreePercent+'%'}" class="progress-bar"></div>
                <span class="review-text">Disagree</span>
                <span class="percentage">{{disAgreePercent}}%</span>
              </div>
              <!--progress end-->
            </div>
          </div>
          <div class="card-footer yellowbg">
            <a [routerLink]="['/'+appService.getCurrentCity()+'/deals/by/'+pollData.merchant.slug]">
              <p>check out more deals from {{pollData.merchant.merchant_name}} <span><i
                class="fa fa-arrow-circle-right"></i></span></p>
            </a>
          </div>
        </div>
        <!--card-back end-->
      </div>

      <!--SOLD OUT CARD-->
      <div class="matches-card soldout-card" *ngIf="!backflip">
        <div class="card-back position-relative">
          <div class="card uk-flex uk-flex-middle">
            <div class="brand-logo ">
              <div class="image">
                <img src="{{pollData.merchant.ipl_logo}}" class="w-100 fitimg">
              </div>
            </div>
            <div class="info">

              <h4>Oh Snap!</h4>
              <p>You just missed the last slot. <span>Better luck next time!</span></p>
            </div>
          </div>
          <img (click)="slidePrev()" src="../assets/images/ipl/close.png" class="close cursor-pointer">
        </div>
        <!--card-back end-->
      </div>
    </ng-template>
  </ng-container>
</swiper>
